import React from 'react';
import { OrganizationalStructureDetailsProvider } from './context/organizational-structure-details-context';
import { OrganizationalStructureDetailsPage } from './organizational-structure-details.page';

export const OrganizationalStructureDetailsFactory: React.FC = () => {
  return (
    <OrganizationalStructureDetailsProvider>
      <OrganizationalStructureDetailsPage />
    </OrganizationalStructureDetailsProvider>
  );
};